export const COACH_BRAND_COLORS = {
  // these colors are meant to be static and hence not using CSS variables
  // maps to closest CDS equivalents
  BLUE_100: '#CFE2FF',
  BLUE_200: '#91D2F3',
  BLUE_300: '#99B9F8',
  BLUE_400: '#5b9dfc',
  BLUE_600: '#1e72eb',
  CYAN_300: '#92E6E7',
  CYAN_400: '#24DBE7',
  GREY_25: '#F2F5FA', // static version of cds grey-25 because we don't want the color theme to affect this
  GREY_75: '#E0E4EA', // between cds-grey-50 and cds-grey-100
  GREY_100: '#DAE1ED', // static version of cds grey-100 because we don't want the color theme to affect this
  GREY_250: '#B6C7D0', // between cds-grey-200 and cds-grey-300
  GREY_350: '#95A2BC', // between cds-grey-300 and cds-grey-400
  GREY_950: '#1E2229', // static version of cds grey-950 because we don't want the color theme to affect this
  GREEN_100: '#AFEFDA',
  GREEN_300: '#76EBC8',
  WHITE: '#FFFFFF',
} as const;

export const DESCRIPT_COLORS = {
  BLUE: '#0062FF',
  GREY: '#343434',
} as const;

// CDS Colors that are needed in hex values
export const BRAND_COLORS = {
  BLUE: '#0056D2',
  BLUISH_WHITE: '#F3F8FF',
} as const;
